import React from 'react';

const SvgComponent = (props) => (
  <svg
    data-name="add circle active-layer"
    viewBox="0 0 18.01 18"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M0 3l2 2 2-2V1.6L2.5 3.2V0h-1v3.2L0 1.6V3zM17.16 9.94L13.63 6.4a1.9 1.9 0 0 0-2.09-.4L6.39 8.57 4.14 6.32A1.9 1.9 0 0 0 1.45 9l5.19 5.2h-.56a1.9 1.9 0 1 0 0 3.8h5.48a3.8 3.8 0 0 0 2.69-1.11L17.16 14a2.85 2.85 0 0 0 0-4zm-.81 3.23l-2.92 2.92a2.64 2.64 0 0 1-1.88.78H6.08a.76.76 0 0 1 0-1.52H9.4l-1.95-2L2.26 8.2a.76.76 0 0 1 1.07-1.08l2.25 2.25.58.58.74-.37L12 7a.76.76 0 0 1 .81.17l3.54 3.54a1.71 1.71 0 0 1 0 2.42z" />
  </svg>
);

export default SvgComponent;
